var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 466.64 105.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Docuz") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.08,14.47V113.9h-20v-8.31Q55.34,115,40.6,115a37.48,37.48,0,0,1-18.42-4.55,32.55,32.55,0,0,1-12.93-13A39.6,39.6,0,0,1,4.56,77.85,39.59,39.59,0,0,1,9.25,58.29a32.55,32.55,0,0,1,12.93-13A37.48,37.48,0,0,1,40.6,40.74q13.8,0,21.58,8.71v-35ZM57.35,92.39Q62.59,87,62.58,77.85T57.35,63.31a17.48,17.48,0,0,0-13.13-5.42A17.67,17.67,0,0,0,31,63.31q-5.22,5.43-5.22,14.54T31,92.39a17.64,17.64,0,0,0,13.27,5.43A17.45,17.45,0,0,0,57.35,92.39Z",
    transform: "translate(-4.56 -9.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.24,110.22A35.36,35.36,0,0,1,102.11,97,36.35,36.35,0,0,1,97,77.85a36.34,36.34,0,0,1,5.1-19.16,35.29,35.29,0,0,1,14.13-13.2,43.24,43.24,0,0,1,20.44-4.75,42.87,42.87,0,0,1,20.37,4.75,35.52,35.52,0,0,1,14.07,13.2,36.42,36.42,0,0,1,5.09,19.16A36.43,36.43,0,0,1,171.12,97a35.59,35.59,0,0,1-14.07,13.2A42.87,42.87,0,0,1,136.68,115,43.24,43.24,0,0,1,116.24,110.22Zm33.64-17.83Q155,87,155,77.85t-5.16-14.54a17.44,17.44,0,0,0-13.2-5.42,17.67,17.67,0,0,0-13.27,5.42q-5.22,5.43-5.22,14.54t5.22,14.54a17.64,17.64,0,0,0,13.27,5.43A17.41,17.41,0,0,0,149.88,92.39Z",
    transform: "translate(-4.56 -9.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.28,110.22a35.36,35.36,0,0,1-19.5-32.37,36,36,0,0,1,5.16-19.16,35.61,35.61,0,0,1,14.34-13.2A44.33,44.33,0,0,1,225,40.74a40.1,40.1,0,0,1,19.9,4.75,28.25,28.25,0,0,1,12.4,13.6L241.06,67.8q-5.62-9.91-16.21-9.91a18.34,18.34,0,0,0-13.53,5.36Q206,68.6,206,77.85t5.36,14.61a18.34,18.34,0,0,0,13.53,5.36q10.72,0,16.21-9.92l16.22,8.85a28.81,28.81,0,0,1-12.4,13.4A39.71,39.71,0,0,1,225,115,44.33,44.33,0,0,1,204.28,110.22Z",
    transform: "translate(-4.56 -9.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342,41.81V113.9H322.13v-8.58a27.65,27.65,0,0,1-9.91,7.17A31.09,31.09,0,0,1,299.75,115q-14.19,0-22.51-8.17t-8.31-24.26V41.81h20.91V79.46q0,17.43,14.6,17.42,7.51,0,12.06-4.89t4.56-14.54V41.81Z",
    transform: "translate(-4.56 -9.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.76,97.82V113.9H356.44V101.3l36.71-43.41H357.37V41.81h62.18V54.4L382.83,97.82Z",
    transform: "translate(-4.56 -9.65)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.14,11.7h-7.33v-2h17.81v2h-7.36v16h-3.12Z",
    transform: "translate(-4.56 -9.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M467.5,19.82c-.19-2.5-.41-5.53-.39-7.76H467q-1.25,3.14-3,6.82l-4.25,8.72H457.4L453.48,19a65.55,65.55,0,0,1-2.75-7h-.08c-.09,2.24-.25,5.24-.48,7.94l-.64,7.71h-2.95l1.68-18h4l4.1,8.71a62.14,62.14,0,0,1,2.42,6h.09a62.05,62.05,0,0,1,2.55-6l4.29-8.71h4l1.49,18h-3.05Z",
    transform: "translate(-4.56 -9.65)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuz);
export default __webpack_public_path__ + "static/media/docuz.9cc76f306a9d3f6fe26410fdf3199be2.svg";
export { ForwardRef as ReactComponent };